window.$ = window.jQuery = require('jquery');
require('vgnav/dist/js/vgnav.min');

require('../vendor/plugins/js/modernizr-3.5.0.min');
require('../vendor/plugins/js/popper.min');
require('../vendor/plugins/js/bootstrap.min');
require('../vendor/plugins/js/owl.carousel.min');
require('../vendor/plugins/js/jquery.meanmenu.min');
require('../vendor/plugins/js/parallax.min');
require('../vendor/plugins/js/jquery.scrollUp.min');
require('../vendor/plugins/js/jquery.magnific-popup.min');
require('../vendor/plugins/js/jquery.nice-select.min');
require('../vendor/plugins/js/jquery.countdown.min');
require('../vendor/plugins/js/ny');
require('../vendor/plugins/js/jquery.inputmask');
require('../vendor/plugins/js/jquery.fancybox');
require('../vendor/plugins/js/jquery.vegasFormSender');
require('../vendor/plugins/js/jquery.vegasSidebar');
require('../vendor/plugins/js/jquery.overlayScrollbars.min');
require('../vendor/plugins/js/imagesloaded.pkgd.min');
require('../vendor/plugins/js/isotope.pkgd.min');
require('../vendor/plugins/js/masonry.pkgd.min');
require('../vendor/plugins/js/dragscroll');

require('./modules/cart');
require('./modules/order');
require('./modules/vegas');
require('./modules/auth');
require('./modules/search');
require('./main');

require('./ym');
require('./functions');